import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=393fba9d"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports